import { EditorPointer } from '@wix/editorx-core-api';
import { PlatformContext } from '../types';
import { CompRef } from '@wix/document-services-types';

const isDataBindingController = (
  documentServicesAPI: PlatformContext['documentServicesAPI'],
  componentRef: CompRef,
): boolean => {
  const compData = documentServicesAPI.components.data.get(componentRef);
  return compData?.applicationId === 'dataBinding';
};

export function hasDataBindingControllerInContext(
  _platformContext: PlatformContext,
  _editorPointer: EditorPointer<CompRef>,
): boolean {
  const { documentServicesAPI, editorPointerAPI } = _platformContext;

  const compRef = editorPointerAPI.getDocumentPointer(_editorPointer);

  const controllers =
    documentServicesAPI.platform.controllers.getAvailableScopedControllers(
      compRef,
    );

  const hasScopedController = controllers.some((controller) => {
    return controller?.applicationId === 'dataBinding';
  });

  const currentPage = documentServicesAPI.pages.getCurrentPage();

  const currentPageChildren =
    documentServicesAPI.components.getChildren(currentPage);

  const hasPageController = currentPageChildren.some((child) =>
    isDataBindingController(documentServicesAPI, child),
  );

  return hasScopedController || hasPageController;
}
